// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBAdizo-a6hx4o7qDNDpkuNQR9K705EzT8",
  authDomain: "info-payangadi.firebaseapp.com",
  projectId: "info-payangadi",
  storageBucket: "info-payangadi.firebasestorage.app",
  messagingSenderId: "236715648766",
  appId: "1:236715648766:web:956d084c875927b7dd27af",
  measurementId: "G-XGJ3RZ934E"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const db = getFirestore(app); 